import { createWebHistory, createRouter } from "vue-router";
import { constantRoutes } from "@/router/route";
import { ElMessage } from "element-plus";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";
import { isHttp, isPathMatch } from "@/utils/validate";
import { isRelogin } from "@/utils/request";
import useUserStore from "@/store/modules/user";
import useSettingsStore from "@/store/modules/settings";
import usePermissionStore from "@/store/modules/permission";

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

NProgress.configure({ showSpinner: false });

// 将白名单提取为单独模块更佳，此处简化处理
const whiteList = ["/login", "/register", "/topo"];
const isWhiteList = (path) => {
  return whiteList.some((pattern) => isPathMatch(pattern, path));
};

// 缓存路由是否已加载，防止重复添加
const addedRouteMap = new Set();

router.beforeEach((to, from, next) => {
  NProgress.start();

  const userStore = useUserStore();
  const permissionStore = usePermissionStore();
  const settingsStore = useSettingsStore();

  if (getToken()) {
    if (to.meta.title) {
      settingsStore.setTitle(to.meta.title);
    }

    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else if (isWhiteList(to.path)) {
      next();
    } else {
      if (userStore.roles.length === 0) {
        isRelogin.show = true;
        userStore
          .getInfo()
          .then(() => {
            isRelogin.show = false;
            return permissionStore.generateRoutes();
          })
          .then((accessRoutes) => {
            accessRoutes.forEach((route) => {
              const routeName = route.name;
              if (!isHttp(route.path) && !addedRouteMap.has(routeName)) {
                router.addRoute(route);
                addedRouteMap.add(routeName);
              }
            });
            next({ ...to });
          })
          .catch((err) => {
            userStore.logOut().then(() => {
              ElMessage.error(err);
              next({ path: "/" });
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (isWhiteList(to.path)) {
      next();
    } else {
      next(`/login?redirect=${to.fullPath}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
